import React from 'react';
import Cropper from 'cropperjs';

//полифилл для toBlob
require('blueimp-canvas-to-blob'); 

export const initCropper = (element, ratio) => {
	let options = {
		moveble: false,
		rotatable: true,
		scalable: true,
		zoomable: false,
		toggleDragModeOnDblclick: false,
		minCropBoxWidth: 16,
		minCropBoxHeight: 16,
		minContainerWidth: 16,
		minContainerHeight: 16,
		minCanvasWidth: 16,
		minCanvasHeight: 16,
		viewMode: 1,
		background: false
	}

	if (ratio) {
		options.aspectRatio = ratio;
	}

	let cropper = new Cropper(element, options);

	return cropper;
}
